import { Commit } from "vuex";
import { ForexApprovalState } from "@/feature/Forex/store/approval/interface";
import { ForexDraftFilter } from "@/feature/Forex/api/draft/forex-draft.interface";
import { ForexApprovalMutation } from "@/feature/Forex/store/approval/constants";
import { getDraftFilter } from "@/feature/Forex/store/draft/utils";
import { ForexOperationType } from "@/feature/Forex/api/forex.interface";

export const getApprovalNextPageFilters = (
	state: ForexApprovalState,
	commit: Commit
): ForexDraftFilter => {
	if (!state.isEndPage)
		commit(ForexApprovalMutation.setNextPage);

	return getDraftFilter(state as any);
};

export const deleteApprovalItems = (
	state: ForexApprovalState,
	ids: number[]
): ForexApprovalState => {
	for (let i = 0; i < state.list.length; i++) {
		if (ids.includes(state.list[i]?.foreignExchangeId!)) {
			state.list[i]?.operationType &&
				state.toApprovalCount.hasOwnProperty(state.list[i].operationType!) &&
				state.toApprovalCount[state.list[i].operationType!]--;

			state.toApprovalCount[ForexOperationType.ALL]--;
		}
	}

	return state;
};